<template>
  <v-toolbar dark fixed>
    <v-toolbar-side-icon @click="toggleDrawer" v-if="apiToken && role"/>
    <v-toolbar-title
      v-if="$route.name === 'home' || $route.name === 'menu'"
    >
      Colina del Manzano
    </v-toolbar-title>
    <v-layout :class="{caption: $route.name === 'reservas'}">
      <v-icon @click="$router.go(-1)" class="ml-3" v-if="$route.name !== 'Login'">$vuetify.icons.chevron-left</v-icon>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-layout>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>
<script>
import mixins from '@/mixins/mixins';

export default {
  mixins: [
    mixins,
  ],
  computed: {
    apiToken() {
      return this.$store.state.sessionData.api_token;
    },
    role() {
      return this.$store.state.sessionData.role;
    },
    reservas() {
      return this.$store.state.reservas;
    },
    title() {
      if (this.$route.name === 'Cabaña') {
        // let coso = this.$store.state.cabins;
        // coso = coso.find((cabin) => {
        //   cabin.id === this.$route.params.id;
        // });
        return this.$store.state.cabins[this.$route.params.id - 1].name;
      } return this.$route.name;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
